/* eslint-disable max-len */
export const errors = {
  'service-is-unavailable': 'Сервис уақытша қолжетімсіз, кейінірек әрекеттеніп көріңіз',
  'cannot-get-telegram-link': 'Telegram-ға сілтеме алына алмады',
  'maybe-error': 'Қате болуы мүмкін',
  'check-email': 'Сізбен байланыса алуымыз үшін e-mail дұрыс екенін тексеріңіз.',
  'check-input-correctness': 'Енгізу дұрыстығын тексеріңіз!',
  'link-possibly-expired': 'Сіздің сілтемеңіз ескірген болуы немесе шаблон жоқ болуы мүмкін. СМ қолдау қызметіне хабарласыңыз',
  'interview-has-already-been-recorded': 'Интервью бұрын жазылып қойған',
  'use-are-using-outdated-browser': 'Өкінішке қарай, Сіздің браузеріңіз заманауи технологияларға сай емес және видеоны жазу сияқты кейбір функциялары қолжетімсіз болуы мүмкін. Дұрыс жұмыс істеуі мен деректерді көрсетуі үшін Chrome, FireFox немесе Edge браузерлерін қолданыңыз.',
  'questionnaire-was-not-sent': 'Сауалнама жіберілмеді',
  'check-data-correctness': 'Енгізіліп жатқан деректердің дұрыстығын тексеріңіз.',
  error: 'Қате',
  'connot-load-questionnaire-template': 'Сауалнаманың шаблоны жүктелмеді, қолдау қызметіне хабарласыңыз.',
  'somthing-went-wrong-try-leter': 'Бірдеңесі дұрыс болмады. Бетті кейінірек ашып көріңіз.',
  'no-answer-was-sent': 'Жауап жіберілмеді',
  'you-can-choose-only-one-variant': 'Тек бір нұсқаны ғана таңдауға болады',
  'full-name-must-contain-three-words': 'ТАӘ жолы бос орын тастап жазылған тура үш сөзден тұруы тиіс!',
  'phone-must-have-format': 'Телефон нөмірі +7 (9NN) NNN-NNNN форматында болуы тиіс!',
  'video-interview-has-already-been-created': 'Видеосұхбат жасалып қойған, сұхбаттан өтіңіз.',
};
